import { render } from "./footerComponent.vue?vue&type=template&id=49dc77e6"
const script = {}

import exportComponent from "C:\\Users\\Livio\\Desktop\\DIploma\\ITSA\\itsa-vue\\ITSA-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__